import React from "react";

import Button from "../../shared/bootstrap/Button.jsx";

import { PAGE_TYPE_ORDERS_LIST } from "../../../constants.js";

export default function Shortcuts() {
  return (
    <div
      id="tabs"
      className="btn-group panel"
      role="group"
      aria-label="Select the button to go directly to that section of the page"
    >
      <a id="orderAppLinkButton" href={`#/${PAGE_TYPE_ORDERS_LIST}`}>
        <Button small={true} text="Back to Orders List" />
      </a>
      <Button
        small={true}
        text="Order General Info"
        onClick={() => document.getElementById("Order_geninfo").scrollIntoView()}
      />
      <Button small={true} text="Contacts" onClick={() => document.getElementById("Order_contacts").scrollIntoView()} />
      <Button
        small={true}
        text="Attachments"
        onClick={() => document.getElementById("Order_attachments").scrollIntoView()}
      />
      <Button
        small={true}
        text="Notes History"
        onClick={() => document.getElementById("Order_notesHistory").scrollIntoView()}
      />
    </div>
  );
}
